export const COLUMN_WIDTH = '14.5rem';

// Week view shrinks days nobody is available on so the working days get the room.
export const COLLAPSED_COLUMN_WIDTH = '4.5rem';
